import dice from "../images/dice.png";
import "../styles/md.css";
export default function MainPageDice() {
  return (
    <span>
      <img className="mainpagedice_size" src={dice} alt={dice} />
    </span>
  );
}
